import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'app-fiche-agence',
  templateUrl: './fiche-agence.component.html',
  styleUrls: ['./fiche-agence.component.css']
})
export class FicheAgenceComponent implements OnInit {

  @Input() agence;
  @Input() client;
  @Input() chantier;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Input() viaFicheClt: Boolean;
  searchCritere = '';
  isEmpty: Boolean = false;
  isRecherche: Boolean = false;
  adresseAutoBAK: Boolean = false;
  dataAdresseBAK: any[] = [];
  listeChantier: any[] = [];
  listeChantierRecherche: any[] = [];
  listDeleteChantier: any[] = [];
  hasScroll: Boolean = false;
  error = '';
  site = {};

  @Output() hidefunction = new EventEmitter<any>();
  @Output() validefunction = new EventEmitter<any>();
  @Output() aftersave = new EventEmitter<any>();

  @ViewChild('msg') msg;
  constructor(protected common: CommonService) { }

  ngOnInit() {
    const societe = this.common.local.getObject('paramSociete') || {};
    this.site = this.common.getType('siteUtilisateur');
    const adresseAutoBAK = this.site['rechercheAdresse'] && (this.site['serviceAdresse'] &&
      this.site['serviceAdresse'].typeServiceAdresse &&
      this.site['serviceAdresse'].typeServiceAdresse.id === 2) ? true : false;
    this.adresseAutoBAK = (societe['rechercheAdresse'] && (societe['serviceAdresse'] &&
      societe['serviceAdresse'].typeServiceAdresse &&
      societe['serviceAdresse'].typeServiceAdresse.id === 2)) || adresseAutoBAK;
    this.agence = this.agence || {};
    this.common.bak = {}
    if (this.add) { this.agence['client'] = this.client; } else {
      this.getChantierClientAgence();
      this.getDetail(this.agence['id']).then(data => {
        this.agence = data;
        this.common.getDetailBak(this.adresseAutoBAK, this.agence['clefBAK']);
        $('#nomagence').click();
      });
    }
    setTimeout(function () {
      $('#nomagence').focus();
    }, 600);
  }

  showFiche() {
    this.hidefunction.emit();
  }

  filtreSearch(event) {
    this.changeInput(event.target.value);
  }

  changeRecherche() {
    if (!this.searchCritere.length) {
      this.isRecherche = false;
    }
  }

  changeInput(indexSelected) {
    const matcher = new RegExp(indexSelected, 'gi');
    if (indexSelected.length) {
      this.isRecherche = true;
    } else {
      this.isRecherche = false;
    }
    $('.info-client .items').show().not(function () {
      return matcher.test($(this).find('.champ').text());
    }).hide();
    if (!$('.group1').find('.items:visible').length) {
      $('.group1 h4').hide();
    } else {
      $('.group1 h4').show();
    }
  }


  editAgence() {
    this.edit = !this.edit;
  }

  saveAgence() {
    this.agence['nomclass'] = 'Agence';
    const param = {
      'servlet': 'DBAgenceSave',
      'module': 'Recylog',
      'type': 'objet',
      'compression': 'false',
      'data': this.agence
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        this.getDetail(datas.data).then(dt => {
          if (!this.viaFicheClt) {
            this.chantier['agence'] = dt;
            this.aftersave.emit(dt);
            this.showFiche();
          } else {
            this.saveChantier(dt);
          }

        });
      }
    });
  }

  getDetail(id) {
    const param = {
      'servlet': 'DBAgenceGet',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_AGENCE': {
          'typeParam': 'int',
          'valeur': id
        }
      }
    };
    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        return datas.data;
      }
    });
  }

  searchAdresseBAK(event) {
    this.dataAdresseBAK = [];
    const param = {
      'servlet': 'DBGestionAdresseRecherche',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 1
        },
        'CHAINE_RECHERCHE': event,
        'CLEF_SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.dataAdresseBAK = datas.data;
        this.dataAdresseBAK.forEach(elt => {
          elt.id = elt.clefBAK;
          elt.libelleObjetEntite = elt.label;
        });
      }
    });
  }

  setValueAdresseBAK(value, name?) {
    if(value && (!value.numero || (value.numero && value.numero === '0'))) {
        value.numero = '';
    }
          
    this.agence['adresse1'] = `${value.numero || ''} ${value.suffixe || ''}`;
    this.agence['adresse2'] = `${value.typeVoie || ''} ${value.nomVoie || ''}`;
    this.agence['adresse3'] = '';
    this.agence['cp'] = value.postcode;
    this.agence['ville'] = value.city;
    this.agence['clefBAK'] = value.clefBAK;
    this.common.bak = value;
  }

  getChantierClientAgence() {
    this.listeChantier = [];
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.client['id'] || 0 // id client
        },
        'CLEF_AGENCE': {
          'typeParam': 'int',
          'valeur': this.agence['id'] || 0 // id agence
        },
        'GET_CHANTIERS_CRITERE_VIDE': {
          'typeParam': 'boolean',
          'valeur': true
        },
        'CRITERE': '' // recherche chantier
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        // $('.fiche').trigger('click');
        this.listeChantier = datas.data;
        console.log(this.listeChantier)
      }
    });
  }

  addLigne() {
    this.listeChantier = this.listeChantier || [];
    this.listeChantier.push({ edit: true });
    this.listeChantier = [...this.listeChantier];
  }

  searchChantier(event) {
    this.listeChantierRecherche = [];
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.client['id']// id client
        },
        'CRITERE': event || '' // recherche chantier
      }
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        datas.data = datas.data || [];
        const temp = [];
        datas.data.forEach(elt => {
          // if (!elt.agence || (elt.agence && elt.agence.id === this.agence['id'])) {

          // }
          const existe = this.listeChantier.filter(cht => cht.id === elt.id);
          if (!existe.length) {
            temp.push(elt);
          }
        })
        this.listeChantierRecherche = temp;
      }
    });
  }

  getDetailChantier(event, row, edit?) {
    const existeChantier = this.listeChantier.filter(elt => elt.id === event.id);
    if (existeChantier.length) {
      // this.error = '';

    } else {
      const param = {
        'servlet': 'DBGetChantier',
        'module': 'Recylog',
        'type': 'tableau',
        'compression': 'false',
        'data': ['DBGetChantier', event.id]
      };

      return this.common.post('', { param: param }).then(datas => {
        if (this.common.verifySession(datas)) {
          row = datas.data[0];
          if (edit) {
            this.listeChantier = this.listeChantier.filter(elt => elt.id);
            row['edit'] = true;
            this.listeChantier.push(row)
          } else {
            if (!this.add) {
              row.agence = {
                id: 0
              }
              this.updateChantier(row);
            }
          }

          console.log(this.listeChantier);
          $('.fiche').trigger('click');
          return row;
        }
      });
    }

  }

  serviceSuppChantier(event) {
    const param = {
      'servlet': 'DBGetChantier',
      'module': 'Recylog',
      'type': 'tableau',
      'compression': 'false',
      'data': ['DBGetChantier', event.id]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        event = datas.data[0];
        event.agence = {
          id: 0
        }
        this.updateChantier(event);
        $('.fiche').trigger('click');
      }
    });
  }

  setValue(event, row) {

  }

  deleteLigne(row) {
    if (row.id) {
      this.serviceSuppChantier(row);
    }
    const temp = this.listeChantier.filter(elt => elt !== row);
    this.listeChantier = temp;
  }

  updateChantier(event) {
    const client = this.client;
    delete event['client'];
    delete event['edit'];
    event.nomclass = 'Chantier';
    const param = {
      'servlet': 'DBSaveChantierHolding',
      'module': 'Recylog',
      'type': 'liste',
      'compression': 'false',
      'data': ['', event, {
        id: '' + (client.id),
        nomclass: 'Client'
      }]
    };

    return this.common.post('', { param: param }).then(datas => {
      if (this.common.verifySession(datas)) {
        if (datas.data !== null) {
          return this.common.createLog('108', event.id, false);
        } else {
          return Promise.reject(datas.message);
        }
      }
    });
  }

  saveChantier(dt) {
    const prom = [];
    if (this.listDeleteChantier.length) {
      this.listDeleteChantier.forEach(elt => {
        elt.agence = {
          id: 0
        }
        const fct = this.updateChantier(elt);
        prom.push(fct);
      });
    }
    const add = this.listeChantier.filter(elt => elt.edit);
    if (add.length) {
      add.forEach(elt => {
        elt.agence = {
          id: dt.id
        }
        const fct = this.updateChantier(elt);
        prom.push(fct);
      });
    }

    console.log(prom)
    if (prom.length) {
      Promise.all(prom).then(data => {
        if (data.length) {
          // this.validefunction.emit(this.bon);
          this.aftersave.emit(dt);
          this.showFiche();
        }
      }).catch(error => {
        this.common.closeModal();
        console.log(error);
      });
    } else {
      this.aftersave.emit(dt);
      this.showFiche();
    }
  }

  detectScroll() {
    const ctrl = this;
    ctrl.hasScroll = false;
    setTimeout(function () {
      const div = $('#tableDocEcoportail');
      if (div[0]) {
        ctrl.hasScroll = div[0].scrollHeight > div[0].clientHeight ? true : false;
      }
    }, 100);
  }
}
